module.exports = __webpack_public_path__ + "img/registered1.afb84531.png";